import { render, staticRenderFns } from "./CreateGeneralAccountPopup.vue?vue&type=template&id=4a8ed1b2"
import script from "./CreateGeneralAccountPopup.vue?vue&type=script&lang=js"
export * from "./CreateGeneralAccountPopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports